import { format } from "date-fns";
import { locale } from "moment";

export const formattaData = (data) => {
    const newData = new Date(data);
    return format(newData, 'dd/MM/yyyy');
}

export const formattaDataOraHHmm = (data) => {
    const newData = new Date(data);
    return format(newData, 'dd/MM/yyyy HH:mm');
}

export const formattaDataOraHHmmss = (data) => {
    const newData = new Date(data);
    return format(newData, 'dd/MM/yyyy HH:mm:ss');
}

export const formattaDataIso8601 = (data) => {
    const newData = new Date(data);
    return newData.toISOString();
}

export const getDataPerDataPicker = (value) => {
    if (!value) return "";
    const d = typeof value === "string" ? new Date(value) : new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear().toString().padStart(4, "0");
    const mm = (d.getMonth() + 1).toString().padStart(2, "0");
    const dd = d.getDate().toString().padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
}

export const dataDaSlashaDash = (dateStr) => {
    if (!dateStr) return '';
    if (dateStr.includes(("-")))
        return dateStr;
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
